import get from 'lodash/get';

export const getKeyName = (obj, keys) => {
  if (!obj) {
    return '';
  }
  let str = '';

  // eslint-disable-next-line array-callback-return
  (typeof keys === 'object' ? keys : [keys]).map((key, index) => {
    str += get(obj, key, '');
    if (index !== keys.length - 1) {
      str += ' ';
    }
  });

  return str;
};
